import axios from 'axios';

import { IZusatzleistung, ZusatzleistungCriteria } from '@/shared/model/zusatzleistung.model';
import buildPaginationQueryOpts from '@/shared/sort/sorts';

const baseApiUrl = 'api/zusatzleistungs';

export default class ZusatzleistungService {
  public find(id: number): Promise<IZusatzleistung> {
    return new Promise<IZusatzleistung>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public changeChecked(list: IZusatzleistung[]): Promise<boolean> {
    return axios.post(`${baseApiUrl}Checked`, list);
  }

  public retrieve(req?: any, criteria?: ZusatzleistungCriteria): Promise<any> {
    return axios.post(`${baseApiUrl}Filter?${buildPaginationQueryOpts(req)}`, criteria);
  }

  public retrieveAll(): Promise<any> {
    return axios.get(`${baseApiUrl}`);
  }

  public retrieveAllSorted(): Promise<any> {
    return axios.get(`${baseApiUrl}FilterNP`);
  }

  public delete(id: number, force: boolean): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}/${force}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IZusatzleistung): Promise<IZusatzleistung> {
    return new Promise<IZusatzleistung>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IZusatzleistung): Promise<IZusatzleistung> {
    return new Promise<IZusatzleistung>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
